import { USER_GCAL_CALENDARS_LIST } from 'infra/actions/types'

const userCalendars = (

  state : Object = { },
  action : Object
) => {
  switch (action.type) {
    case USER_GCAL_CALENDARS_LIST:
    {
      return Object.assign({
        list: action.payload
      }, state)
    }
    default:
      return state
  }
}

export default userCalendars



// WEBPACK FOOTER //
// ./src/infra/reducers/gcal/userCalendars.js